export default "__VITE_ASSET__Bk_9v5XY__"